import type { PropsWithChildren } from "react"

import { Footer } from "./Footer"
import { Navbar } from "./Navbar"

export function AppLayout({ children }: PropsWithChildren) {
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900">
      <Navbar />
      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  )
}
